import { AutomatorBuilderPublishSetting } from '../_base';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-setting-completed-runs' )
export class AutomatorBuilderPublishSettingCompletedRuns extends AutomatorBuilderPublishSetting {
	// Unique identifier for this setting.
	settingID = 'recipe_completed_runs';

	// Icon representing this setting in the UI.
	icon = 'check-circle';

	// Label displayed for this setting in the UI.
	label = escapeHTML( __( 'Completed runs', 'uncanny-automator' ) );

	/**
	 * Retrieves a readable version of the "Completed runs" field value for display.
	 *
	 * @return {Number} The number of completed runs
	 */
	get readableValue() {
		// Get the value of the field "Completed runs"
		const completedRuns = this.getFieldValue( 'COMPLETED_RUNS' );

		return completedRuns;
	}

	/**
	 * Modifies the default template to include an edit button to add a link instead
	 * @return {TemplateResult|undefined} The button to view the logs
	 */
	get _templateEditButton() {
		return html`
			<div class="setting-edit-button">
				<uo-button
					size="extra-small"
					color="transparent"

					href=${ UncannyAutomator._recipe.miscellaneous.url_logs }
					target="_blank"
				>
					${ escapeHTML( __( 'View logs', 'uncanny-automator' ) ) }
				</uo-button>
			</div>
		`;
	}
}
